const userRoles = {
    INDIVIDUAL: "individual",
    FIRM: "firm",
    STAFF: "staff",
    ADMINISTRATOR: "administrator"
}

export default {
    userRoles
}